const Required = () => (
  <span className="text-red-600 ml-1">*</span>
)

export default Required